import { useId } from 'react';
import { StyledContainer, StyledSvg } from './AppConnectWiresWire.styled';

const AppConnectWiresWire = ({
	colors,
	side,
}: {
	colors: { start: string; end: string };
	side: 'left' | 'right';
}) => {
	const id = useId();
	return (
		<StyledContainer $side={side}>
			<StyledSvg width="12" height="32" viewBox="0 0 12 32" fill="none">
				<rect
					x="1"
					y="1"
					width="10"
					height="30"
					rx="5"
					fill={`url(#paint0_linear_${id})`}
				/>
				<rect
					x="0.5"
					y="0.5"
					width="11"
					height="31"
					rx="5.5"
					stroke="black"
					strokeOpacity="0.5"
				/>
				<rect
					opacity="0.5"
					x="1.5"
					y="1.5"
					width="9"
					height="29"
					rx="4.5"
					stroke={`url(#paint1_linear_${id})`}
				/>
				<circle cx="6" cy="26" r="2" fill="black" />
				<circle
					cx="6"
					cy="26"
					r="2.5"
					stroke={`url(#paint2_linear_${id})`}
					strokeOpacity="0.5"
				/>
				<circle cx="6" cy="6" r="2" fill="black" />
				<circle
					cx="6"
					cy="6"
					r="2.5"
					stroke={`url(#paint3_linear_${id})`}
					strokeOpacity="0.5"
				/>
				<defs>
					<linearGradient
						id={`paint0_linear_${id}`}
						x1="6"
						y1="1"
						x2="6"
						y2="31"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor={colors.start} />
						<stop offset="1" stopColor={colors.end} />
					</linearGradient>
					<linearGradient
						id={`paint1_linear_${id}`}
						x1="6"
						y1="1"
						x2="6"
						y2="31"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="0.509615" stopColor="white" stopOpacity="0" />
					</linearGradient>
					<linearGradient
						id={`paint2_linear_${id}`}
						x1="6"
						y1="24"
						x2="6"
						y2="28"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="0.740385" stopColor="white" stopOpacity="0" />
					</linearGradient>
					<linearGradient
						id={`paint3_linear_${id}`}
						x1="6"
						y1="4"
						x2="6"
						y2="8"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="0.740385" stopColor="white" stopOpacity="0" />
					</linearGradient>
				</defs>
			</StyledSvg>
		</StyledContainer>
	);
};

export { AppConnectWiresWire };
